module.exports = __webpack_public_path__ + "assets/d9bfe30ff802adc0142f14b4d9462fc7.mp3";